'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_cartListItem from './tpl/cartListItem.html';
import language from '../../../common/language';
import config from '../../../common/config';

export default Marionette.ItemView.extend({
    tagName: 'tr',
    className :'blacc',
    getTemplate: function () {
        return tpl_cartListItem({ model: this.model.toJSON() });
    },
    initialize: function () {
        this.app = this.options.app;

        this.model.attributes.TotalPrice = this.model.attributes.Price * this.model.attributes.Qty;
        this.listenTo(this.model, 'change', this.render, this);
        //this.model.bind('change', this.render, this);
    },
    ui: {
        'cartListItem_btnAddCart' : '#cartListItem_btnAddCart',
        'cartListItem_inputQty' : '#cartListItem_inputQty',
        'cartListItem_tdTotalPrice' : '#cartListItem_tdTotalPrice',
        'cartListItem_btnDelete' : '#cartListItem_btnDelete',
        'cartListItem_divBtn' : '#cartListItem_divBtn',
        'cartListItem_imgImage01' : '#cartListItem_imgImage01'
    },
    events: {
        'click @ui.cartListItem_btnAddCart': 'btnAddCart',
        'click @ui.cartListItem_btnDelete': 'btnDelete',
        'change @ui.cartListItem_inputQty': 'inputQtyChange'
    },
    onRender: function () {
        if (this.model.attributes.ConfigShopFreight == -2) {
            this.ui.cartListItem_inputQty.css('display', 'none');
            this.ui.cartListItem_divBtn.css('display', 'none');
            this.ui.cartListItem_imgImage01.css('display', 'none');
        }
    },
    btnDelete: function (event) {
        event.preventDefault();

        var userChannel = Backbone.Radio.channel('app');
        userChannel.trigger('cart:deleteItem', this.model);
    },
    btnAddCart: function (event) {
        event.preventDefault();

        var userChannel = Backbone.Radio.channel('app');
        userChannel.trigger('menu:shopProduct', this.model);
    },
    inputQtyChange: function (event) {
        event.preventDefault();

        var qty = parseInt(this.ui.cartListItem_inputQty[0].value);
        this.model.attributes.Qty = qty;

        this.model.attributes.TotalPrice = this.model.attributes.Qty * this.model.attributes.Price;
        this.model.collection.trigger('change');

        var userChannel = Backbone.Radio.channel('app');
        userChannel.trigger('cart:recalculate');
    }
}, Backbone.Radio.Requests);